import React from 'react'
import { Button } from 'reactstrap'
import OrcamentoConsultaService from "../../../../services/OrcamentoConsultaService";
import { observable } from "mobx";
import { sortCaret, DocumentoCheck, DocumentoView, PixIcon } from "../../../comum/components/Icones"
import { buscaFiltrarVazio, buscaSemResultado } from "../../../../utils/mensagens";
import { formatarDataCustomHTML, formatarReal, situacaoOrcamentoFormatter, formatNullableValue } from "../../../../utils/formatar";
import moment from 'moment';
import LoadingImage from '../../../comum/components/LoadingImage';
import FileSaver from 'file-saver'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { urlApi } from '../../../../config/Constantes';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default class ConsultaStore {

    @observable filtrado;
    @observable loading;
    @observable loadingDetalhe;
    @observable loadingCancelar;
    @observable loadingDemonstrativo;
    @observable detalhesData;
    @observable listaDetalhe;
    @observable itens;
    @observable hasMore;
    @observable tipos;
    @observable tipoSelecionado;
    @observable situacoes;
    @observable situacaoSelecionada;
    @observable container;
    @observable cliente;
    @observable nota;
    @observable bl;
    @observable tableMessage;
    @observable mensagem;

    @observable modalCancelar;
    @observable modalDetalhes;
    @observable modalBoleto;
    @observable modalNovoOrcamento;
    @observable modalAlerta;
    @observable tipoOrc;
    @observable naoGeraOrcamentoIndisponivel;
    @observable modalTempSSA;

    @observable telaExport;
    @observable telaImport;

    @observable modalPagamentoPix;
    @observable isPix;
    @observable dataPix;
    @observable valorTotal;

    constructor() {        
        this.itens = []
        this.tipos = []
        this.situacoes = []
        this.orcamentos = []
        this.listaDetalhe = []
        this.colunas = this.todasColunas
        
        this.tipoSelecionado = null
        this.situacaoSelecionada = null
        this.detalhesData = null
        
        this.tableMessage = buscaFiltrarVazio
        this.container = ""
        this.mensagem = ""
        this.cliente = ""
        this.nota = ""
        this.bl = ""
        
        this.file;

        this.turn = 0
        this.toShow = 20
        
        this.filtrado = false
        this.loading = false
        this.hasMore = false
        this.loadingDetalhe = false
        this.loadingCancelar = false
        this.loadingDemonstrativo = false

        this.modalCancelar = false
        this.modalDetalhes = false
        this.modalBoleto = false
        this.tipoOrc = "";
        this.modalNovoOrcamento = false;
        this.modalAlerta = false;

        this.telaExport = false;
        this.telaImport = false;

        this.download = document.createElement('a');
        document.body.appendChild(this.download);
        this.download.style = "display: none";
        this.download.target = "_blank";

        this.service = new OrcamentoConsultaService()
        this.naoGeraOrcamentoIndisponivel = false;
        this.modalTempSSA = false;
        this.listarSituacao()
        this.listarTipos()

        this.modalPagamentoPix = false;
        this.isPix = false;
        this.dataPix = {};    
        this.valorTotal = 0;    
    }

    listar = () => {
        this.tableMessage = ""
        this.filtrado = true
        this.loading = true
        let val;
        if(this.situacaoSelecionada === "A") val = "A";
        else if(this.situacaoSelecionada) val = this.situacaoSelecionada.value;
        this.service.Listar(this.bl, this.container, this.cliente, this.nota, this.tipoSelecionado ? this.tipoSelecionado.value : "", this.situacaoSelecionada ? val : "").then(response => {
            if(response && response.data) {
                this.orcamentos = response.data.OrcInfoList

                this.loadFirstTurn()

                if(this.orcamentos.length === 0) this.tableMessage = buscaSemResultado
            }
        }).catch(err => console.error(err)
        ).finally(() => this.loading = false)
    }

    loadFirstTurn = () => {
        this.itens = this.orcamentos.slice(0, this.toShow)
        this.turn = 1
        this.hasMore = this.itens.length < this.orcamentos.length
    }

    loadNextTurn = () => {
        this.itens = []
        this.itens = this.orcamentos.slice(0, (this.turn+1)*this.toShow)
        this.turn = this.turn+1

        this.hasMore = this.itens.length < this.orcamentos.length
    }

    listarSituacao = () => {
        this.service.ListarSituacao().then(response => {
            if(response && response.data) {
                this.situacoes = response.data.map(situacao => ({label: situacao.Descr, value: situacao.Codigo}))
            }
        }).catch((err) => console.error(err))
    }

    listarTipos = () => {
        this.service.ListarTipo().then(response => {
            if(response && response.data) {
                this.tipos = response.data.map(tipo => ({label: tipo.Descr, value: tipo.Codigo}))
            }
        }).catch((err) => console.error(err))
    }

    
    abrirModalPagamentoPix = () => {
        this.modalPagamentoPix = true;
    }

    fecharModalPagamentoPix = () => {
        this.modalPagamentoPix = false;
    }


    setTipo = (valor) => {
        this.tipoSelecionado = valor
    }

    setSituacao = (valor) => {
        this.situacaoSelecionada = valor
    }

    setBl = (valor) => {
        this.bl = valor
    }

    setContainer = (valor) => {
        this.container = valor
    }
    
    setCliente = (valor) => {
        this.cliente = valor
    }

    setNota = (valor) => {
        this.nota = valor
    }

    fecharModalMensagem = () => {
        this.mensagem = ""
    }

    abrirModalNovoOrcamento = () => {
        this.modalNovoOrcamento = true;
    }

    mostrarAlerta = () => {
        this.modalNovoOrcamento = false;
        if (this.tipoOrc === "imp")
            this.modalAlerta = true
        else
            this.redirecionarOrcamento();
    }

    fecharModalNovoOrcamento = () => {
        this.modalNovoOrcamento = false;
        this.tipoOrc = ""
    }

    fecharTelaImportExport = () => {
        this.telaExport = false;
        this.telaImport = false;
    }

    redirecionarOrcamento = () => {
        this.modalAlerta = false;
        switch(this.tipoOrc) {
            case 'imp':
                this.telaExport = false;
                this.telaImport = true;
            break;
            case 'exp':
                this.telaExport = true;
                this.telaImport = false;
            break;
            default:
                null
        }
    }

    mudarNovoOrcamento = (event) => {
        this.tipoOrc = event.target.value
    }

    toggleModal = (cell, row, modal, value) => {
        this.cell = cell
        this.row = row
        switch(modal) {
            case 'cancelar':
                this.modalCancelar = value
                break;
            case 'detalhes':
                if(value) this.detalhes(row.Id)
                    this.modalDetalhes = value
                break;
            default:
                null
        }
    }

    detalhes = (detalheId) => {
    this.loadingDetalhe = true
    this.service.Detalhe(detalheId).then(response => {
            this.detalhesData = response.data
            this.listaDetalhe = response.data.OsServList ? response.data.OsServList : []
        }).catch(err => console.error(err)
        ).finally(() => this.loadingDetalhe = false)
    }

    gerarPix = (_, row) => {
        this.service.RecuperarPix(row.Id).then(res => {
            if(res && res.data) {
                if (res.data.Sucesso){
                    this.valorTotal = row.ValorOrcamento;
                    this.dataPix = res.data;
                    this.modalPagamentoPix = true;
                } else {
                    this.mensagem = res.data.Mensagem
                }
            } else {
                this.mensagem = "Ocorreu um erro inesperado.";
            }
        })
    }
    gerarBoleto = (cell, row) => {
        this.service.ExibirBoleto(row.Id).then(response => {
            if(response && response.data) {
                if(response.data.Sucesso) {
                    this.abrirBoleto(response.data.PDF);
                } else {
                    this.mensagem = response.data.Mensagem;
                }
            }
        }).catch(err => console.error(err));
    }

    base64ToPdfBlob = (base64) => {
        const byteCharacters = atob(base64);
        const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: 'application/pdf' });
    };

    abrirBoleto = (base64) => {
        const blob = this.base64ToPdfBlob(base64, "application/pdf");
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
    };

    getDemonstrativo = (doc="", dtFimServ="") => {
        this.loadingDemonstrativo = true;
        let fetchURL =`${urlApi}/OrcamentoWebConsulta/Demonstrativo?documento=${doc}&dtFimServ=${dtFimServ}`;
        fetch(fetchURL)
            .then(r =>{
                if(r.status !== 200) {
                    console.log(r)
                    if(r.status === 404) {
                        this.mensagem = "Nada foi encontrado. Código 404.";
                    } else {
                        this.mensagem = r.data;
                    }
                }
                else 
                {
                    this.download.href = fetchURL;
                    this.download.click();
                }
            }).catch(err => console.log(err)
            ).finally(() => {this.loadingDemonstrativo = false});
    }

    cancelarOrcamento = () => {
        this.loadingCancelar = true;
        this.service.Cancelar(this.row.Id).then(response => {
            if(response && response.data) {
                if(response.data.Sucesso) {
                    response.data.Mensagem ? this.mensagem = response.data.Mensagem : this.mensagem = "Cancelamento realizado com sucesso"
                } else {
                    response.data.Mensagem ? this.mensagem = response.data.Mensagem : this.mensagem = "Cancelamento não realizado"
                }
            }
        }).catch((err) => console.error(err)
        ).finally(() => {
            this.loadingCancelar = false;
            this.toggleModal(null, null, 'cancelar', false);
            this.listar();
        });
    }

    renderDemonstrativo = (cell, row) => {
        if(cell) {
            return <LoadingImage />
        } else if(["A","C", "P", "V"].includes(row.Status)){
            return(<span onClick={() => this.getDemonstrativo(row.Documento, moment(row.DtVencimento).format("DD-MM-YYYY"))}><DocumentoView style={{cursor: 'pointer'}} width={24} /></span>);
        } else {
            return "---";
        }
    }

    formatTipo = (cell) => {
        switch(cell) {
            case 'E':
                return 'Exportação';
            case 'I':
                return 'Importação';
            case 'T':
                return 'Transito'
            default:
                null;
        }
    }

    todasColunas = [
        {
            text: "Orç.",
            dataField: "Id",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret
        },
        {
            text: "Cliente",
            dataField: "RazaoCliente",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret
        },
        {
            text: "Emissão",
            dataField: "DtOrcamento",
            sort: true,
            headerAlign: () => "left",
            formatter: formatarDataCustomHTML,
            sortCaret: sortCaret
        },
        {
            text: "Pagamento",
            dataField: "DtPagamento",
            sort: true,
            headerAlign: () => "left",
            formatter: formatarDataCustomHTML,
            sortCaret: sortCaret
        },
        {
            text: "Tipo",
            dataField: "TipoOrcamento",
            sort: true,
            headerAlign: () => "left",
            formatter: this.formatTipo,
            sortCaret: sortCaret
        },
        {
            text: "Nota",
            dataField: "Notas",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret
        },
        {
            text: "Total",
            dataField: "ValorOrcamento",
            sort: true,
            formatter: formatarReal,
            headerAlign: () => "left",
            sortCaret: sortCaret
        },
        {
            text: "Usuário Cancelamento",
            dataField: "UsuarioCancelamento",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret
        },
        {
            text: "Data Cancelamento",
            dataField: "DtCancelamento",
            sort: true,
            formatter: formatarDataCustomHTML,
            headerAlign: () => "left",
            sortCaret: sortCaret
        },
        {
            text: "Situação",
            dataField: "StatusDesc",
            sort: true,
            headerAlign: () => "center",
            align: "center",
            formatter: situacaoOrcamentoFormatter,
            sortCaret: sortCaret
        },
        {
            text: "Demonstr.",
            dataField: "Demonstrativo",
            sort: true,
            hidden: process.env.rig,
            align: "center",
            typeButton: "Demonstrativo",
            buttonOnclick:this.getDemonstrativo,
            formatter: (cell, row) => this.renderDemonstrativo(cell, row),
            sortCaret: sortCaret
        },
        {
            text: "Tipo Pagamento",
            dataField: "FlgPix",
            sort: true,
            headerAlign: () => "center",
            align: "center",
            hidden: true,
        },
        {
            text: "Detalhes",
            dataField: "PermiteVisualizarDetalhe",
            sort: true,
            align: "center",
            typeButton: "Detalhes",
            inputClick:"detalhes",
            buttonOnclick:this.toggleModal,
            formatter: (cell, row) => <span onClick={() => this.toggleModal(cell, row,'detalhes',true)}><DocumentoView style={{cursor: 'pointer'}} width={24} /></span>,
            sortCaret: sortCaret
        },
        {
            text: "Boleto/PIX",
            dataField: "PermiteVisualizarBoleto",
            sort: true,
            align: "center",
            typeButton: "Boleto",
            formatter: (cell, row) => cell ? 
                <span onClick={() => { if(row.FlgPix == "S") this.gerarPix(cell, row);
                                       else this.gerarBoleto(cell, row)}}>
                    {
                        (row.FlgPix == "S") ?
                            <PixIcon style={{cursor: 'pointer'}} width={22} onClick={() => this.gerarPix(cell, row)}/>
                        :
                            <DocumentoCheck style={{cursor: 'pointer'}} width={22} onClick={() => this.gerarBoleto(cell, row)} />
                    }
                </span> : "---",
            sortCaret: sortCaret,
        },
        {
            text: "Ação",
            dataField: "PermiteCancelar",
            sort: true,
            align: "center",
            typeButton: "Cancelar",
            inputClick:"cancelar",
            buttonOnclick: this.toggleModal,
            formatter: (cell, row) => cell ? <Button className="btn-com-bordas-cinza px-2" onClick={() => this.toggleModal(cell, row,'cancelar',true)}>Cancelar</Button> : "---",
            sortCaret: sortCaret
        },
    ]

    colunasDetalhes = [
        {
            text: "OS",
            dataField: "OsId",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret
        },{
            text: "Descrição",
            dataField: "DscTipoServico",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret
        },{
            text: "Unitário",
            dataField: "ValorUnitario",
            sort: true,
            headerAlign: () => "left",
            formatter: formatarReal,
            sortCaret: sortCaret
        },{
            text: "QTD",
            dataField: "Qtde",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret
        },{
            text: "Total",
            dataField: "ValorTotal",
            sort: true,
            headerAlign: () => "left",
            formatter: formatarReal,
            sortCaret: sortCaret
        },{
            text: "A Pagar",
            dataField: "ValorPagar",
            sort: true,
            headerAlign: () => "left",
            formatter: formatarReal,
            sortCaret: sortCaret
        },
    ]
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/consulta/stores/ConsultaStore.js